import {ExperimentNames, hasImage} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useWidgetState} from '../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {shouldShowPromotionalBadge} from '../../../../selectors/events'
import {EventImage} from '../../../event-image'
import {PromotionalBadge} from '../../../promotional-badge'
import s from './image.scss'

export interface ImageProps {
  event: wix.events.Event
}

export const Image = ({event}: ImageProps) => {
  const {
    allBreakpoints: {isListImageEnabled, isPromotionalBadgeOnImage},
  } = useVisibilityStyles()
  const {experiments} = useExperiments()

  const showPromotionalBadge = useWidgetState(state => shouldShowPromotionalBadge(state, event))

  return isListImageEnabled() ? (
    <div data-hook={hasImage(event) ? DH.listImage : DH.listImagePlaceholder} className={s.image}>
      <EventImage event={event} backgroundFallback />
      {experiments.enabled(ExperimentNames.PromotionalBadges) &&
        showPromotionalBadge &&
        isPromotionalBadgeOnImage() && (
          <div className={s.promotionalBadge}>
            <PromotionalBadge onImage event={event} />
          </div>
        )}
    </div>
  ) : null
}
